import * as React from 'react';
import Form from "./LoginForm";

export function Login() {
    return (
    <div className="flex w-full h-screen">
        <div className="w-full flex items-center justify-center lg:w-1/2">
            <Form />
        </div>
        <div className="hidden relative lg:flex h-full w-1/2 items-center justify-center bg-gray-200">
            <div className="w-80 h-80 bg-gradient-to-tr from-violet-500 to-pink-500 rounded-full animate-bounce"/>
            <div className="w-full absolute bottom-0 h-1/2 bg-white/10 backdrop-blur-lg"/>
        </div>
    </div>
    )
}